"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mobile = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = _interopRequireDefault(require("./styles"));

var _Group = require("./Group");

var Mobile =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Mobile, _React$Component);

  function Mobile() {
    (0, _classCallCheck2.default)(this, Mobile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Mobile).apply(this, arguments));
  }

  (0, _createClass2.default)(Mobile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          className = _this$props.className,
          groups = _this$props.groups,
          selectedKeysSet = _this$props.selectedKeysSet,
          onSelectKey = _this$props.onSelectKey,
          onRemoveKey = _this$props.onRemoveKey;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_styles.default.root, className)
      }, groups.map(function (g) {
        return _react.default.createElement(_Group.Group, {
          key: g.key,
          theme: theme,
          group: g,
          selectedKeysSet: selectedKeysSet,
          onSelectKey: onSelectKey,
          onRemoveKey: onRemoveKey
        });
      }));
    }
  }]);
  return Mobile;
}(_react.default.Component);

exports.Mobile = Mobile;
Mobile.propTypes = {
  theme: _propTypes.default.object.isRequired,
  className: _propTypes.default.string.isRequired,
  groups: _propTypes.default.array.isRequired,
  selectedKeysSet: _propTypes.default.instanceOf(Set).isRequired,
  onSelectKey: _propTypes.default.func.isRequired,
  onRemoveKey: _propTypes.default.func.isRequired
};